import { Component } from '@angular/core';

@Component({
    selector: 'recover-header',
    standalone: true,
    imports: [],
    templateUrl: './recover-header.component.html',
})
export class RecoverHeaderComponent {}
